import { render, staticRenderFns } from "./AddProductForVehicle.vue?vue&type=template&id=4798768a&scoped=true"
import script from "./AddProductForVehicle.vue?vue&type=script&lang=js"
export * from "./AddProductForVehicle.vue?vue&type=script&lang=js"
import style0 from "./AddProductForVehicle.vue?vue&type=style&index=0&id=4798768a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798768a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4798768a')) {
      api.createRecord('4798768a', component.options)
    } else {
      api.reload('4798768a', component.options)
    }
    module.hot.accept("./AddProductForVehicle.vue?vue&type=template&id=4798768a&scoped=true", function () {
      api.rerender('4798768a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/AddProductForVehicle.vue"
export default component.exports